import React from 'react';
import Typed from 'typed.js';

import { FaLinkedinIn } from "react-icons/fa6";
import { FaGithub, FaWhatsapp } from "react-icons/fa";
import Navbar from "../Navbar";
import AchievementCard from '../AchievementCard'
import Certifications from '../Certifications'
import Skills from '../Skills'
import Projects from '../Projects'
import Journey from '../Journey'
import Contact from '../Contact'
import { Heading, Robot, Homepage,Spline1, MainContainer, HomeContainer, Profession, Description, ResumeButton, LinkButton, Achievements, Box, SubBox, Dot,Image } from './style.js'
import ThemeContext from '../../context/ThemeContext.js';

const achievements = [
    {
        id: '1',
        heading: '1000+',
        description: 'Coding Problems',
    },
    {
        id: '2',
        heading: '30+',
        description: 'Projects',
    },
    {
        id: '3',
        heading: '1+',
        description: 'Years Experience',
    },
    {
        id: '4',
        heading: '9.55',
        description: 'CGPA',
    },
]
const Home = () => {
    // https://jsfiddle.net/mattboldt/60h9an7y/ for more reference

    const el = React.useRef(null);

    const typed = React.useRef(null);

    React.useEffect(() => {
        const options = {
            strings: ['a Cyber security Learner', 'a Coder', 'an AI Enthusiastic', 'a Full Stack Developer'],
            typeSpeed: 100,
            backSpeed: 100,
            loop: true,
        };

        // elRef refers to the <span> rendered below
        typed.current = new Typed(el.current, options);

        return () => {
            // Make sure to destroy Typed instance during cleanup
            // to prevent memory leaks
            typed.current.destroy();
        }
    }, [])
    console.log(window.innerWidth)
    return (
        <ThemeContext.Consumer>
            {value => (
                <Homepage theme={value.theme}>
                    <Navbar />
                    <div>
                        <MainContainer>
                            <HomeContainer>
                                <Heading theme={value.theme}>HI ! I'm Narasimha Charyulu</Heading>
                                <Profession><span style={{ color: value.theme === 'light' ? '#000000' : '#FFFFFF' }}>I am </span><span ref={el} /></Profession>
                                <Description theme={value.theme}>I break down complex user experience problems to create integrity focussed solutions that connect billions of people</Description>
                                <div style={{ display: 'flex' }}>
                                    <ResumeButton  theme={value.theme} href="resume.pdf" download>Download Resume</ResumeButton>
                                    <LinkButton theme={value.theme} href="https://api.whatsapp.com/send?phone=9490588867&text=Hi I am interested to work with you" target="_blank"><FaWhatsapp /></LinkButton>
                                    <LinkButton theme={value.theme} href="https://github.com/Narasimha2005" target="_blank"><FaGithub /></LinkButton>
                                    <LinkButton theme={value.theme} href="https://www.linkedin.com/in/narasimhachitturi" target="_blank"><FaLinkedinIn /></LinkButton>
                                </div>
                            </HomeContainer>
                            {/* picture */}
                            <Image src="https://ctmirror.org/wp-content/uploads/2021/01/dummy-man-570x570-1.png"/>
                            {window.innerWidth>992?
                            <Robot>
                                <Spline1 scene="https://prod.spline.design/J0cGADXIUOqtiPuy/scene.splinecode"/>
                            </Robot>:null}
                        </MainContainer>
                        <Achievements>
                            {achievements.map(eachItem => (<AchievementCard key={eachItem.id} details={eachItem}/>))}
                        </Achievements>
                    </div>
                    <div id="skills">
                        <Skills />
                    </div>
                    <div id="projects">
                        <Projects />
                    </div>
                    <div id="education">
                        <Journey />
                    </div>
                    <div id="certifications">
                        <Certifications />
                    </div>
                    <div id="contact">
                        <Contact />
                    </div>
                    <Box>
                        <SubBox><Dot></Dot></SubBox>
                        <SubBox><Dot></Dot></SubBox>
                        <SubBox><Dot></Dot></SubBox>
                        <SubBox><Dot></Dot></SubBox>
                        <SubBox><Dot></Dot></SubBox>
                        <SubBox><Dot></Dot></SubBox>
                        <SubBox><Dot></Dot></SubBox>
                        <SubBox><Dot></Dot></SubBox>
                        <SubBox><Dot></Dot></SubBox>
                        <SubBox><Dot></Dot></SubBox>
                    </Box>
                </Homepage>
            )}
        </ThemeContext.Consumer>
    )
}

export default Home